var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunityOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14226_5198)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.99992,
    cy: 3.33334,
    r: 1.66667,
    stroke: "#313131",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 6.66667,
    rx: 2.5,
    ry: 1.66667,
    stroke: "#313131",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.9999,
    cy: 13.3333,
    r: 1.66667,
    stroke: "#313131",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667M10.0001 18.3333C5.39771 18.3333 1.66675 14.6024 1.66675 10",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 16.6667,
    rx: 2.5,
    ry: 1.66667,
    stroke: "#313131",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14226_5198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityOutline);
export default __webpack_public_path__ + "static/media/community-outline.8f546d7612a737f808a9570bc4af32be.svg";
export { ForwardRef as ReactComponent };